import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { ColumnChart, ColumnChartItem } from './ColumnChart';

type Props = {
  title: string;
  items: ColumnChartItem[];
  maxValue: number;
};

/** Карточка с заголовком и вертикальной столбчатой диаграммой. */
export const ColumnChartCard: FC<Props> = ({ title, items, maxValue }) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent>
      <ColumnChart items={items} maxValue={maxValue} />
    </CardContent>
  </Card>
);
